import React, { useContext, useState } from "react";
import styles from "../styles/modal.module.css";
import StateContext from "../context/state/StateContext";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import UserContext from "../context/user/UserContext";

const Confirm = (props) => {
  const {
    confirm,
    setConfirm,
    setTickets,
    detail,
    setDetail,
    groups,
    setGroups,
    agencies,
    setAgencies,
    loading,
    setLoading
  } = useContext(StateContext);
  
  const { getEmployees, getTickets } = useContext(UserContext)
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  const handlelogout = () => {
    if (token) {
      localStorage.removeItem("token");
      navigate("/");
      props.close({ open: false, component: "" });
    }
  };

  const handleDelete = async (id) => {
    const token = localStorage.getItem("token");
    try {
      setLoading({ open: true, text: 'Deleting...' })
      await handleCancleSchedule(id);
      const response = await axios.delete(
        process.env.REACT_APP_API_URL + `api/ticket/delete/${id}`,
        {
          headers: {
            "Content-Type": "application/json",
            "auth-token": `${token}`,
          },
        }
      );

      const json = response.data;
      if (json.success) {
        setDetail({ open: false, data: "" });
        setTickets((prevTickets) =>
          prevTickets.filter((item) => item.id !== id)
        );
        toast.success(json.message);
        // props.close({ open: false, component: '' })
      } else {
        toast.error(json.error || json.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setConfirm({ component: "", promise: false, text: "" });
      setLoading({ open: false, text: '' })
    }
  };

  const handleCancleSchedule = async (id) => {
    const token = localStorage.getItem("token");
    try {
      // setLoading({ open: true, text: 'Cancelling...' })
      const response = await axios.get(
        process.env.REACT_APP_API_URL + `api/ticket/unschedule/${id}`,
        {
          headers: {
            "Content-Type": "application/json",
            "auth-token": `${token}`,
          },
        }
      );

      const json = response.data;
      if (json.success) {
        getTickets();
        if (json.message !== "No schedules found") {
          toast.success(json.message);
        }
        // props.close({ open: false, component: '' })

      } else {
        toast.error(json.error || json.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setConfirm({ component: "", promise: false, text: "" });
      // setLoading({ open: false, text: '' })
    }
  };
  const handleUserDelete = async (id) => {
    const token = localStorage.getItem("token");
    try {
      setLoading({ open: true, text: 'Updating...' })
      const response = await axios.delete(
        process.env.REACT_APP_API_URL + `api/auth/delete`,
        {
          headers: {
            "Content-Type": "application/json",
            "auth-token": `${token}`,
          }, data: { id },
        }
      );

      const json = response.data;
      if (json.success) {
        toast.success(json.message);
        // props.close({ open: false, component: '' })
        getEmployees();
      } else {
        toast.error(json.error || json.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading({ open: false, text: '' })
      setConfirm({ component: "", text: "" });
    }
  };
  const handleSubmit = () => {
    if (confirm.component == "Logout") {
      handlelogout();
      props.close({ open: false, component: "" });
      setConfirm({ component: "", ticketId: "", text: "" });
    } else if (confirm.component == "Ticket") {
      handleDelete(confirm.ticketId);
      setConfirm({ component: "", ticketId: "", text: "" });
      props.close({ open: false, component: "" });
    } else if (confirm.component === "Schedule") {
      handleCancleSchedule(confirm.ticketId);
      setConfirm({ component: "", ticketId: "", text: "" });
      props.close({ open: false, component: "" });
    } else if (confirm.component === "Group") {
      handleGroupDelete(confirm.ticketId);
      setConfirm({ component: "", ticketId: "", text: "" });
      props.close({ open: false, component: "" });
    } else if (confirm.component === "Agency") {
      handleAgencyDelete(confirm.ticketId);
      setConfirm({ component: "", ticketId: "", text: "" });
      props.close({ open: false, component: "" });
    } else if (confirm.component === "User") {
      handleUserDelete(confirm.ticketId);
      setConfirm({ component: "", ticketId: "", text: "" });
      props.close({ open: false, component: "" });
    }
  };

  const handleGroupDelete = async (id) => {
    try {
      await setLoading({ open: true, text: "Adding" })

      const response = await fetch(
        process.env.REACT_APP_API_URL + `api/group/delete/${id}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            "auth-token": `${token}`,
          },
        }
      );

      const result = await response.json();
      if (result.success) {
        setGroups(groups.filter((group) => group.id !== id));
        toast.success(result.message);
      } else {
        console.error("Failed to delete group");
        toast.error(result.message);
      }
    } catch (error) {
      toast.error("Internal Server Error",error)
    } finally{
      await setLoading({ open: false, text: '' })
    }
  };

  const handleAgencyDelete = async (id) => {
    try {
      await setLoading({ open: true, text: "Deleting" })

      const response = await fetch(
        process.env.REACT_APP_API_URL + `api/agency/delete/${id}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            "auth-token": `${token}`,
          },
        }
      );

      const result = await response.json();
      if (result.success) {
        setAgencies(agencies.filter((agency) => agency.id !== id));
        toast.success(result.message);
      } else {
        console.error("Failed to delete Agency");
        toast.error(result.message);
      }
    } catch (error) {
      toast.error("Internal Server Error",error)
    } finally{
      await setLoading({ open: false, text: '' })
    }
  };

  return (
    <>
      <div className={styles.head}>
        <h3></h3>
        <i
          className={`bx bx-x ${styles.close}`}
          onClick={() => props.close({ open: false, component: "" })}
        ></i>
      </div>
      <div className="text-center">
        <h4>{confirm.text}</h4>
      </div>
      <div className={styles.foot}>
        <div className="d-flex align-items-center" style={{ gap: "20px" }}>
          <button
            type="button"
            className="button2 cancel"
            onClick={() => props.close({ open: false, component: "" })}
          >
            Cancel
          </button>
          <button type="submit" className={`button2`} onClick={handleSubmit}>
            Confirm
          </button>
        </div>
      </div>
    </>
  );
};

export default Confirm;
